import i18n, { languageCacheKey as cacheKey } from "@/i18n/i18n"

export function getCurrentLanguage() {
  return localStorage.getItem(cacheKey) || i18n.locale
}

export function setCurrentLanguage(lang) {
  localStorage.setItem(cacheKey, lang)
  i18n.locale = lang
}